import { Stack, Text } from 'braid-design-system';
import type { FC } from 'react';

import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';
import { FormattedDateSpan, type MonthYear } from 'src/libs/FormattedDateSpan';

import { TextDisclosureWithLinks } from '../TextDisclosureWithLinks';

export interface RoleProps {
  title: string;
  company: string;
  from: MonthYear;
  to?: MonthYear | null;
  achievements?: string | null;
}

export const Role: FC<RoleProps> = ({
  title,
  company,
  from,
  to,
  achievements,
}) => {
  const { locale } = useAppConfig();
  return (
    <Stack space="small">
      <Text weight="strong" maxLines={1}>
        {title}
      </Text>
      <Text size="small">{company}</Text>
      <FormattedDateSpan
        from={from}
        to={to}
        textProps={{
          size: 'small',
          tone: 'secondary',
        }}
        locale={locale}
      />
      {achievements ? (
        <TextDisclosureWithLinks
          size="small"
          linesToPreview={3}
          text={achievements}
        />
      ) : null}
    </Stack>
  );
};
